import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { SiteShell } from './components/SiteShell';
import HomePage from './pages/HomePage';

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

function PageMeta({ title, description }: { title: string; description: string }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <SiteShell>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <PageMeta
                    title="SELF Phone — Resonatia Mesh Node | SELF Labs"
                    description="SELF Phone is your Resonatia mesh node. Download models, sync to the network, and earn Essence. AI-native hardware with global satellite signal and Aura Shield."
                  />
                  <HomePage />
                </>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </SiteShell>
      </Router>
    </HelmetProvider>
  );
}